import React from 'react';
import {DiscountCodeStatusEnum} from "@/lib/helper/enumType";

function DiscountStatusEnumComponent({text}) {

    if (!text || text === 'none') {
        return <span></span>
    } else {
        return <> <i className={`${DiscountCodeStatusEnum(text, `color`)}`}></i>
            <span className={DiscountCodeStatusEnum(text, `color`)}>{DiscountCodeStatusEnum(text)}</span></>
    }

}

export default DiscountStatusEnumComponent;